module.exports = __webpack_public_path__ + "img/INVITATO_DX.e9bc730d.png";